<template>
  <div class="study-progress">
    <div class="study-progress-intro" v-if="detail && detail.intro">
      <p class="study-progress-intro-p" v-html="detail.intro"></p>
    </div>

    <div v-if="!isWorkCommit || !isFullProgress" class="un-commit">
      <img width="198" height="138" src="../../../assets/progress0.png" />
      <p>课程还未全部学习或作业还未提交</p>
      <p>请继续努力加油哦！</p>
    </div>

    <template v-else-if="isWorkCommit && isFullProgress">
      <div class="finish-tip">
        <img width="30" height="30" src="../../../assets/finished.png" />
        <span>恭喜您已完成全部课程学习</span>
      </div>

      <el-form
        :model="formModel"
        :rules="rules"
        ref="formRef"
        label-width="100px"
      >
        <el-form-item label="姓名" prop="name">
          <span v-if="isExpressAddress">{{ detail.expressAddress.name }}</span>
          <el-input v-else class="w510" v-model="formModel.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <span v-if="isExpressAddress">{{ detail.expressAddress.phone }}</span>
          <el-input v-else class="w510" v-model="formModel.phone"></el-input>
        </el-form-item>
        <el-form-item
          label="地区"
          prop="provinceId"
          :rules="{ required: true, message: '省份不能为空' }"
        >
          <span v-if="isExpressAddress" class="area">
            <span style="margin-right: 10px">{{ provinceName }}</span>
            <span style="margin-right: 10px">{{ cityName }}</span>
            <span style="margin-right: 10px">{{ districtName }}</span>
          </span>
          <template v-else>
            <el-select
              v-model="formModel.provinceId"
              placeholder="请选择"
              @change="onProvinceChange"
            >
              <el-option
                v-for="province in provinces"
                :label="province.areaName"
                :key="province.id"
                :value="province.id"
              ></el-option>
            </el-select>
            <el-form-item
              prop="cityId"
              style="display: inline-block"
              :rules="{ required: true, message: '城市不能为空' }"
            >
              <el-select
                v-model="formModel.cityId"
                placeholder="请选择"
                @change="onCityChange"
              >
                <el-option
                  v-for="province in cityies"
                  :label="province.areaName"
                  :key="province.id"
                  :value="province.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="districtId"
              style="display: inline-block"
              :rules="{ required: true, message: '区县不能为空' }"
            >
              <el-select v-model="formModel.districtId" placeholder="请选择">
                <el-option
                  v-for="province in districts"
                  :label="province.areaName"
                  :key="province.id"
                  :value="province.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-form-item>
        <el-form-item
          label="详细地址"
          prop="address"
          :rules="{
            required: true,
            message: '请输入详细地址',
          }"
        >
          <span v-if="isExpressAddress">{{
            detail.expressAddress.address
          }}</span>
          <el-input
            v-else
            type="address"
            class="w510"
            v-model="formModel.address"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="!isExpressAddress">
          <el-button type="primary" @click="onSave"> 提交作品信息 </el-button>
          <p>信息一旦提交不可修改，请仔细核对</p>
        </el-form-item>
      </el-form>
    </template>
  </div>
</template>

<script>
import { getStudyProgress, commitExpressAddress } from "@/api/course";
import { getProvince, getCity, getDistrict } from "@/api/common";

export default {
  name: "StudyProgress",
  props: {
    courseId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formModel: {
        name: "",
        phone: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        address: "",
      },
      provinces: [],
      cityies: [],
      districts: [],
      rules: {
        name: [{ required: true, message: "请输入姓名" }],
        phone: [{ required: true, message: "请输入手机号" }],
      },
      detail: null,

      provinceName: "",
      cityName: "",
      districtName: "",
    };
  },
  computed: {
    isWorkCommit({ detail }) {
      if (detail) {
        // 是否交作业 0 否 1 是
        return detail.isWorkCommit === 1;
      }
      return false;
    },
    isFullProgress({ detail }) {
      if (detail) {
        // 学习进度是100
        return detail.courseProgress === 10000;
      }

      return false;
    },
    isExpressAddress({ detail }) {
      if (detail) {
        return detail.expressAddress !== null;
      }

      return false;
    },
  },
  async created() {
    await this.getStudyProgress();
    this.getProvince();
  },
  methods: {
    async getProvinceLabel() {
      const { detail, isExpressAddress } = this;
      if (!isExpressAddress) return;
      // const { data } = await getProvince();
      const province = this.provinces.find(
        (item) => item.id === detail?.expressAddress.provinceId
      );
      if (province) {
        this.provinceName = province.areaName;
        this.getCityLabel(province.id);
      }
    },
    async getCityLabel(provinceId) {
      const { detail, isExpressAddress } = this;
      if (!isExpressAddress) return;
      const { data } = await getCity(provinceId);
      const city = data.find(
        (item) => item.id === detail?.expressAddress.cityId
      );
      if (city) {
        this.cityName = city.areaName;
        this.getDistrictLabel(city.id);
      }
    },
    async getDistrictLabel(cityId) {
      const { detail, isExpressAddress } = this;
      if (!isExpressAddress) return;
      const { data } = await getDistrict(cityId);
      const district = data.find(
        (item) => item.id === detail?.expressAddress.districtId
      );
      if (district) {
        this.districtName = district.areaName;
      }
    },
    getProvince() {
      getProvince().then(({ data }) => {
        this.provinces = data;
      });
    },
    getCity(provinceId) {
      getCity(provinceId).then(({ data }) => {
        this.cityies = data;
      });
    },
    getDistrict(cityId) {
      getDistrict(cityId).then(({ data }) => {
        this.districts = data;
      });
    },
    onProvinceChange(provinceId) {
      this.formModel.cityId = "";
      this.formModel.districtId = "";
      this.getCity(provinceId);
    },
    onCityChange(cityId) {
      this.formModel.districtId = "";
      this.getDistrict(cityId);
    },
    getStudyProgress() {
      getStudyProgress(this.courseId).then(({ data }) => {
        this.detail = data;

        if (this.isExpressAddress) {
          this.getProvinceLabel();
        }
      });
    },
    onSave() {
      this.$refs.formRef.validate(async (res) => {
        if (!res) return;

        commitExpressAddress({
          ...this.formModel,
          courseId: this.courseId,
        }).then(() => {
          this.$message.success("提交成功");
          this.getStudyProgress();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .w510 {
  width: 510px;
}

::v-deep .el-input__inner {
  background-color: transparent;
}

::v-deep .el-input__inner {
  color: #fff;
}

::v-deep .el-form-item__label {
  color: #fff;
}

.study-progress {
  &-intro {
    width: 800px;
  }

  &-intro-p {
    display: inline-block;
    padding: 13px 20px;
    background-color: #e6f2ff;
    border-radius: 4px;
    color: #046bde;
  }
}

.un-commit {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    margin-bottom: 17px;
  }

  p {
    font-weight: 400;
    font-size: 16px;
    color: #788a9f;
  }
}

.finish-tip {
  margin: 30px 0 30px 110px;
  display: flex;
  align-items: center;

  span {
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    margin-left: 10px;
  }
}


</style>
